import React, { useEffect } from 'react';
import { Alert as MuiAlert, Box, Stack, Typography } from '@mui/material';

import { Button } from '../components/core';
import { useInheritedSettingsBannerContext } from '../contexts/InheritedSettingsBannerContext';
import { useMerchant } from '../contexts/MerchantContext';
import {
  getChildCustomizeInheritedWarningCopy,
  getChildInheritedInfoBannerCopy,
} from '../util/parentSettingSave';
import { Alert } from '../pages/Paylinks/components/Alert';

type Props = {
  isCustomizingInherited: boolean;
  readOnly?: boolean;
  onCustomize: () => void;
};

/** Child merchant: inherited setting banner and Customize flow (UNO-2239). */
export function InheritedConfigSettingCallouts({
  isCustomizingInherited,
  readOnly = false,
  onCustomize,
}: Props) {
  const { hasDescendants } = useMerchant();
  const { setChildInheritedInfoBannerActive } = useInheritedSettingsBannerContext();

  useEffect(() => {
    setChildInheritedInfoBannerActive(true);
    return () => setChildInheritedInfoBannerActive(false);
  }, [setChildInheritedInfoBannerActive]);

  return (
    <Stack spacing={1.5} sx={{ mb: 2, maxWidth: hasDescendants ? 720 : 520 }}>
      {!isCustomizingInherited ? (
        <>
          <MuiAlert severity="info" sx={{ fontSize: 12, py: 0.5 }}>
            <Typography component="span" color="inherit" sx={{ fontSize: 12 }}>
              <Typography component="span" fontWeight={600} color="inherit">
                Note:
              </Typography>{' '}
              {getChildInheritedInfoBannerCopy(hasDescendants)}
            </Typography>
          </MuiAlert>
          {!readOnly ? (
            <Box>
              <Button
                text="Customize"
                theme="secondary"
                onClick={onCustomize}
                dataTestId="inherited-setting-customize-button"
              />
            </Box>
          ) : null}
        </>
      ) : (
        <Alert severity="warning" size="small">
          {getChildCustomizeInheritedWarningCopy(hasDescendants)}
        </Alert>
      )}
    </Stack>
  );
}
